(() => {
  if (window.TCGPreorder) return;

  const selector = '[data-tcg-preorder-cutoff]';
  const buttonAttributes = ['data-tcg-preorder-cutoff', 'data-tcg-preorder-button', 'data-tcg-preorder-regular-label'];
  let expiryTimer;

  function cutoff(element) {
    const value = Number(element?.getAttribute('data-tcg-preorder-cutoff'));
    return Number.isFinite(value) && value > 0 ? value : 0;
  }

  function isActive(element, now = Date.now()) {
    return now < cutoff(element);
  }

  function buttonLabel(button, fallback, now = Date.now()) {
    if (isActive(button, now) && button.hasAttribute('data-tcg-preorder-button')) {
      return button.getAttribute('data-tcg-preorder-button');
    }
    return button?.getAttribute('data-tcg-preorder-regular-label') || fallback;
  }

  function syncButtonState(destination, source) {
    if (!destination) return;
    buttonAttributes.forEach((name) => {
      if (source?.hasAttribute(name)) destination.setAttribute(name, source.getAttribute(name));
      else destination.removeAttribute(name);
    });
  }

  function updateElement(element, now) {
    if (element.hasAttribute('data-tcg-preorder-button')) {
      const label = element.querySelector('[data-tcg-preorder-label]') || element.querySelector('span');
      // Keep Sold out/Unavailable and in-flight/error states under the product form's control.
      if (label && !element.disabled && element.getAttribute('aria-disabled') !== 'true' && !label.classList.contains('hidden')) {
        const text = buttonLabel(element, label.textContent, now);
        if (label.textContent !== text) label.textContent = text;
      }
    }
    if (isActive(element, now)) return;
    if (element.hasAttribute('data-tcg-preorder-schema-after')) {
      const schema = element.getAttribute('data-tcg-preorder-schema-after');
      try {
        JSON.parse(schema);
        if (element.textContent !== schema) element.textContent = schema;
      } catch {}
    }
    // Omit expired disclosures from future FormData, without changing existing cart/order items.
    if (element.hasAttribute('data-tcg-preorder-property')) element.disabled = true;
    if (element.hasAttribute('data-tcg-preorder-badge')) element.hidden = true;
    if (element.hasAttribute('data-tcg-preorder-notice')) {
      const after = element.getAttribute('data-tcg-preorder-notice-after');
      if (after) { element.hidden = false; if (element.textContent !== after) element.textContent = after; }
      else element.hidden = true;
    }
    if (element.hasAttribute('data-tcg-preorder-checkout')) {
      const wasHidden = element.hidden;
      element.hidden = false;
      if (wasHidden) {
        const submit = element.closest('product-form')?.querySelector('[name="add"]');
        submit?.classList.remove('button--primary');
        submit?.classList.add('button--secondary');
        window.Shopify?.PaymentButton?.init();
      }
    }
    if (element.hasAttribute('data-tcg-preorder-after')) {
      const text = element.getAttribute('data-tcg-preorder-after');
      if (element.textContent !== text) element.textContent = text;
    }
  }

  function scheduleExpiry() {
    clearTimeout(expiryTimer);
    const now = Date.now();
    let next = Infinity;
    document.querySelectorAll(selector).forEach((element) => {
      const end = cutoff(element);
      if (end > now) next = Math.min(next, end);
    });
    if (Number.isFinite(next)) {
      expiryTimer = setTimeout(() => refresh(), Math.min(next - now + 20, 2147483647));
    }
  }

  function refresh(root = document) {
    const now = Date.now();
    if (root.matches?.(selector)) updateElement(root, now);
    root.querySelectorAll(selector).forEach((element) => updateElement(element, now));
    scheduleExpiry();
  }

  window.TCGPreorder = Object.freeze({ isActive, buttonLabel, syncButtonState, refresh });

  function start() {
    refresh();
    new MutationObserver((records) => {
      if (records.some((record) => Array.from(record.addedNodes).some((node) => node.nodeType === 1))) refresh();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) refresh();
  });
  window.addEventListener('pageshow', () => refresh());
})();

